<template>
    <div>
        <lable>ユーザ</lable>
    </div>
</template>
<script>
export default {
    
}
</script>